export default __webpack_public_path__ + "f384188700bf2e249e36efc5112de0e5.png";